import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M304-186q-17 0-29-11-11-12-11-28 0-17 11-29 12-11 29-11h274q65 0 111-45t46-110q0-64-46-109t-111-45H297l77 77q12 12 12 28t-12 28q-11 12-27 12t-28-13L174-586q-6-6-10-13-3-7-3-15t3-15q4-7 10-13l145-145q12-12 28-12t27 12q12 12 12 28t-12 28l-77 77h280q98 0 168 68t70 166q0 98-70 166t-168 68H304Z"/>',
  f: '<path d="M304-186q-17 0-29-11-11-12-11-28 0-17 11-29 12-11 29-11h274q65 0 111-45t46-110q0-64-46-109t-111-45H297l77 77q12 12 12 28t-12 28q-11 12-27 12t-28-13L174-586q-6-6-10-13-3-7-3-15t3-15q4-7 10-13l145-145q12-12 28-12t27 12q12 12 12 28t-12 28l-77 77h280q98 0 168 68t70 166q0 98-70 166t-168 68H304Z"/>',
};

export default data;
